/* eslint-disable @typescript-eslint/no-explicit-any */
import { STRINGS } from 'config';

const {
  REDUCERS: { WALLET },
} = STRINGS;

export interface OrderItem {
  productId: string;
  type: string;
  label: string;
  quantity: number;
  unitAmountPence: number;
  currency: string;
  details?: {
    seconds?: number;
  };
}
export interface StripeInfo {
  sessionId: string;
}
export interface Order {
  _id: string;
  userId: string;
  status: 'PENDING' | 'PAID' | 'CANCELED' | 'EXPIRED' | 'REFUNDED' | string;
  currency: string;
  details: {
    items: OrderItem[];
  };
  totalAmountPence: number;
  stripe: StripeInfo;
  createdAt: string;
  updatedAt: string;
  __v: number;
}
export interface Product {
  id: string;
  type: string;
  label: string;
  title: string;
  bulletPoints: string[];
  buttonText: string;
  unitAmountPence: number;
  currency: string;
  details: {
    seconds?: number;
    durationSeconds?: number;
  };
}

export interface Pass {
  label: string;
  durationSeconds: number;
  id: string;
}

export interface Passes {
  remainingPasses: Pass[];
  activePass: Pass | null;
}

export interface Topup {
  freeBalanceSeconds: number | null;
  paidBalanceSeconds: number | null;
  freeResetAt: string | null;
  totalUsableSeconds: number | null;
}

export interface SubscriptionType {
  kind: 'UNLIMITED'; // later extended
}

export interface WalletState {
  topup: Topup | null;
  orders: Order[] | null;
  shouldShowDayPassFlag: boolean;
  passes: Passes | null;
  products?: Product[] | null;
  autoCutoffMsRemaining: number | null;
  subscription: SubscriptionType | null;
  termsAccepted: boolean;
}

export function hasUnlimitedSub(sub: SubscriptionType | null) {
  return sub?.kind?.toLowerCase() === 'unlimited';
}

export const initialWalletState: WalletState = {
  topup: {
    freeBalanceSeconds: null,
    paidBalanceSeconds: null,
    freeResetAt: null,
    totalUsableSeconds: null,
  },
  orders: null,
  shouldShowDayPassFlag: false,
  passes: null,
  products: null,
  autoCutoffMsRemaining: null,
  subscription: null,
  termsAccepted: false,
};

export const walletReducer = (state: WalletState = initialWalletState, action: any): WalletState => {
  switch (action.type) {
    case WALLET.GET_WALLET_SUCCESS:
      return { ...state, ...action.payload };
    case WALLET.GET_ORDERS_SUCCESS:
      return { ...state, orders: action.payload };
    case WALLET.GET_PRODUCTS_SUCCESS:
      return { ...state, products: action.payload };
    case WALLET.SET_SHOW_DAY_PASS_FLAG:
      return { ...state, shouldShowDayPassFlag: action.payload };
    case WALLET.ACCEPT_TERMS_SUCCESS:
      return { ...state, termsAccepted: true };
    default:
      return state;
  }
};

export default walletReducer;
